if (!customElements.get('libertas-quick-shop')) {
  class LibertasQuickShop extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.addEventListener('click', (event) => {
        const opener = event.target.closest('[data-quick-shop-open]');
        if (opener) {
          this.open(opener);
          return;
        }
        if (event.target.closest('[data-quick-shop-close]')) {
          this.close(event.target.closest('dialog'));
        }
      }, { signal });

      this.querySelectorAll('dialog').forEach((dialog) => {
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) this.close(dialog);
        }, { signal });
        dialog.addEventListener('close', () => {
          if (this.restoreFocus !== false) this.lastTrigger?.focus();
          this.restoreFocus = true;
        }, { signal });
      });
      document.addEventListener('cart:updated', () => {
        const openDialog = this.querySelector('dialog[open]');
        if (!openDialog) return;
        this.restoreFocus = false;
        this.close(openDialog);
      }, { signal });

      this.addEventListener('change', (event) => {
        const select = event.target.closest('[data-quick-shop-variant]');
        if (select) this.updateVariant(select);
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      delete this.dataset.ready;
    }

    open(trigger) {
      const dialog = this.querySelector(`#${CSS.escape(trigger.getAttribute('aria-controls'))}`);
      if (!dialog) return;
      this.lastTrigger = trigger;
      window.libertasPrepareScrollLock?.();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      requestAnimationFrame(() => dialog.querySelector('[data-quick-shop-close]')?.focus());
    }

    close(dialog) {
      if (!dialog) return;
      if (typeof dialog.close === 'function') dialog.close();
      else {
        dialog.removeAttribute('open');
        this.lastTrigger?.focus();
      }
    }

    updateVariant(select) {
      const dialog = select.closest('dialog');
      const option = select.selectedOptions[0];
      const form = dialog?.querySelector('form[action*="/cart/add"]');
      const idInput = form?.querySelector('[name="id"]');
      const submit = form?.querySelector('[type="submit"]');
      const price = dialog?.querySelector('[data-quick-shop-price]');
      const comparePrice = dialog?.querySelector('[data-quick-shop-compare-price]');
      if (idInput) idInput.value = select.value;
      if (price) price.textContent = option.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || '';
        comparePrice.hidden = !option.dataset.comparePrice;
      }
      if (submit) {
        const available = option.dataset.available === 'true';
        submit.disabled = !available;
        submit.textContent = available ? submit.dataset.availableLabel : submit.dataset.soldLabel;
      }
    }
  }

  customElements.define('libertas-quick-shop', LibertasQuickShop);
}
